module.exports = __webpack_public_path__ + "img/img_09@2x.b8706b51.png";